import React from 'react'

import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function QuoteThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 200">
      <rect x={0} y={0} width={150} height={200} className={classes.paper} />
      <rect x={15} y={20} width={45} height={20} className={classes.fill} />
      <rect x={90} y={20} width={45} height={20} className={classes.fill} />

      <rect x={15} y={60} width={120} height={20} className={classes.fill} />
      <rect x={15} y={90} width={120} height={20} className={classes.fill} />
      <rect x={15} y={120} width={120} height={20} className={classes.fill} />

      <rect x={90} y={160} width={45} height={20} className={classes.fill} />
    </svg>
  )
}
